module.exports = parcelRequire.resolve("bz9q9");